import { Component, OnInit, Input } from '@angular/core';
import { ReconocimientosService } from 'src/app/_services/reconocimientos.service';
import { Router } from '@angular/router';
import { ReconocimientoObj } from 'src/app/_modules/reconocimientos/models/reconocimiento-obj';
import { Observable } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';

@Component({
  selector: 'app-glm-reconocimiento-card',
  standalone: false,
  templateUrl: './glm-reconocimiento-card.component.html',
  styleUrls: ['./glm-reconocimiento-card.component.scss']
})
export class GlmReconocimientoCardComponent implements OnInit {

  @Input()
  hijoId: number;

  @Input()
  hijoNombres: string;

  // labelMisBoletines: string;

  boletines$: Observable<{categoria: string, categoriaDisplay: string, alumnoId: number, reconocimientos: ReconocimientoObj[]}[]>
    = this.boletinesService.reconocimientos$.pipe(
    take(1),
    map(data => {
      if (this.hijoId) {
        // const resp = [];
        // data.forEach(item => {
        //   const newReconocimientos = item.reconocimientos.filter(recon => recon.alumnoId === this.hijoId);
        //   resp.push({categoria: item.categoria, categoriaDisplay: item.categoriaDisplay, reconocimientos: newReconocimientos});
        // });
        // return resp;
        return data.filter(item => item.alumnoId === this.hijoId);
      } else {
        return data;
      }
    })
  );

  viewMore = false;

  constructor(private boletinesService: ReconocimientosService) {
  }

  ngOnInit() {
  }

  labelMisBoletines(): string {
    return this.hijoNombres ? 'Reconocimientos' : 'Mis reconocimientos';
    // return this.hijoNombres ? 'Boletines de ' + this.hijoNombres : 'Mis boletines';
  }

}
